// =====================================================================
// tpCustomer — Opportunity commission helpers
//
// Pure functions only — same shape as churn-metrics.js so the self-tests
// in opportunities-tests.js can call them under node with a minimal
// `global.window = {}` shim. No DOM, no React, no D.* lookups.
//
// Lives in its own file rather than inline in opportunities.jsx because
// the .jsx is not directly require()-able in node (JSX syntax). Anything
// the Commercials tab needs to share with the test harness moves here.
// =====================================================================

(function () {
  'use strict';

  // Single source of truth for "which roles are both rendered and counted
  // in the committed total". The partner row is suppressed on deals with
  // no partner attached (the rate still lives in opp.commission so the
  // editor can re-seed it on attach), so it must also be excluded from
  // the total — otherwise the table shows e.g. 8 + 1 + 0.5 = 24.5%, with
  // a phantom 15% partner default folded in.
  function commissionTotalPct(rates, roleKeys, options) {
    const showPartnerRow = !!(options && options.showPartnerRow);
    const keys = showPartnerRow ? roleKeys : roleKeys.filter(function (k) { return k !== 'partner'; });
    return keys.reduce(function (s, k) {
      var n = Number(rates[k]);
      return s + (Number.isFinite(n) ? n : 0);
    }, 0);
  }

  if (typeof window !== 'undefined') {
    window.tpCommission = { commissionTotalPct: commissionTotalPct };
  }
})();
